import release from '../../../version.json'

/** The apps that show a version and offer a refresh when a newer one is out. */
export type AppName = 'gym' | 'member'

/**
 * Each app's own release number, from version.json. The gym app and the member
 * app are numbered separately, so a change to one never tells the other's users
 * to refresh. The Worker reads the same file and reports every app's latest
 * number on every response; each app compares only its own.
 */
export const APP_VERSIONS: Record<AppName, string> = {
  gym: release.gym,
  member: release.member,
}
